// Overview aggregation endpoints — back the redesigned CourseHome "what do I
// do today?" surface.

import { api } from './client.js';

export type PrioritySource = 'briefing' | 'sensor_alert' | 'weather_alert' | 'disease_risk';

export interface PriorityItem {
  id: string;
  priority: 'P1' | 'P2' | 'P3';
  category: string;
  title: string;
  detail: string;
  action: string | null;
  source: PrioritySource;
}

export interface PrioritiesResponse {
  source: 'briefing' | 'synthesized';
  forDate: string;
  priorities: PriorityItem[];
}

export function getTodayPriorities(
  courseSlug: string,
  opts: { holeId?: number } = {},
): Promise<PrioritiesResponse> {
  const q = opts.holeId != null ? `?holeId=${opts.holeId}` : '';
  return api.get<PrioritiesResponse>(`/courses/${courseSlug}/overview/priorities${q}`);
}

export interface HealthSparklinePoint {
  date: string;
  score: number;
}

export interface CourseHealthResponse {
  score: number | null;
  delta7d: number | null;
  sparkline: HealthSparklinePoint[];
  windowDays: number;
  sampleCount: number;
}

export function getCourseHealth(
  courseSlug: string,
  days = 30,
  opts: { holeId?: number } = {},
): Promise<CourseHealthResponse> {
  const params = new URLSearchParams({ days: String(days) });
  if (opts.holeId != null) params.set('holeId', String(opts.holeId));
  return api.get<CourseHealthResponse>(
    `/courses/${courseSlug}/overview/health?${params.toString()}`,
  );
}

export interface WaterSavedResponse {
  synthetic: true;
  monthToDate: true;
  actualGallons: number;
  baselineGallons: number;
  savedGallons: number;
  dollarsSaved: number;
  baselineFactor: number;
}

export function getWaterSaved(courseSlug: string): Promise<WaterSavedResponse> {
  return api.get<WaterSavedResponse>(`/courses/${courseSlug}/overview/water-saved`);
}
